import { render } from "./SuccessSnackbar.vue?vue&type=template&id=04f3cab3&ts=true"
import script from "./SuccessSnackbar.vue?vue&type=script&lang=ts"
export * from "./SuccessSnackbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__